import { defaultNumberOfStudents, defaultTypeClasses } from "conts";
import { createContext, useContext, useState } from "react";

const TimingContext = createContext({});

export const TimingProvider = ({ children }) => {
  const [selectedTimings, setSelectedTimings] = useState([]);
  const [numberOfStudents, setNumberOfStudents] = useState(
    defaultNumberOfStudents
  );
  const [typeOfClass, setTypeOfClass] = useState(defaultTypeClasses.Private);

  const handleAddSelectedTiming = (timing) => {
    setSelectedTimings((prev) => [...prev, timing]);
  };

  const clearStore = () => {
    setSelectedTimings([]);
    setNumberOfStudents(defaultNumberOfStudents);
    setTypeOfClass(defaultTypeClasses.Private);
  };

  const handleRemoveSelectedTiming = ({ id, date }) => {
    setSelectedTimings((prev) =>
      prev.filter((prevDate) => prevDate.id !== id || prevDate.date !== date)
    );
  };

  const handleResetSelectedTiming = () => {
    setSelectedTimings([])
  }

  const handleChangeTypeOfClass = (value) => {
    setTypeOfClass(value);
    setSelectedTimings([]);
    setNumberOfStudents(defaultNumberOfStudents);
  };

  return (
    <TimingContext.Provider
      value={{
        selectedTimings,
        numberOfStudents,
        typeOfClass,
        handleAddSelectedTiming,
        clearStore,
        handleResetSelectedTiming,
        handleRemoveSelectedTiming,
        handleChangeNumberOfStudents: setNumberOfStudents,
        handleChangeTypeOfClass,
      }}
    >
      {children}
    </TimingContext.Provider>
  );
};

export const useSelectedTimings = () => {
  const context = useContext(TimingContext);
  if (!context) {
    throw new Error("useSelectedTimings must be used within TimingProvider");
  }
  return context;
};
